"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRenderDataWithErrorFunction = exports.renderError = exports.renderNoData = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
function renderNoData() {
    return react_1.default.createElement(data_catalog_shared_1.CenteredMessage, { message: catalog_messages_1.Messages.ErrorNoData() });
}
exports.renderNoData = renderNoData;
function renderError(errorCode) {
    return react_1.default.createElement(data_catalog_shared_1.CenteredMessage, { message: (0, data_catalog_shared_1.getMessageForErrorCode)(errorCode) });
}
exports.renderError = renderError;
function createRenderDataWithErrorFunction(renderData) {
    return (data, errorCode) => renderDataWithError(data, errorCode, renderData);
}
exports.createRenderDataWithErrorFunction = createRenderDataWithErrorFunction;
function renderDataWithError(data, errorCode, renderData) {
    if (errorCode) {
        if ((0, data_catalog_shared_1.isFatalError)(errorCode)) {
            return renderError(errorCode);
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                renderData(data),
                (0, data_catalog_shared_1.reportGraphQLError)(errorCode)));
        }
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            renderData(data),
            (0, data_catalog_shared_1.reportGraphQLError)(null)));
    }
}
//# sourceMappingURL=ErrorMessageWidgets.js.map